


















import { Component, Vue, Prop, Ref } from 'vue-property-decorator'

@Component
export default class TextBox extends Vue {
  @Prop({ required: false }) readonly invalid?: boolean;
  @Prop({ required: false, default: false }) readonly disabled?: boolean;
  @Prop({ required: false, default: '' }) readonly placeholder?: string;
  @Prop({ required: true }) isMobile!: boolean
  @Ref() readonly textarea!: HTMLTextAreaElement

  textareaId = `${Math.random()}`

  isScrolledDown: boolean = false
  contentExtendsBelowBorder: boolean = false

  computeOverlayVisibilities () {
    const visibleHeight = this.textarea.offsetHeight
    const scrollableHeight = this.textarea.scrollHeight
    const scrolledDistance = this.textarea.scrollTop
    const lineHeight = 30
    this.isScrolledDown = scrolledDistance > lineHeight
    this.contentExtendsBelowBorder = scrolledDistance + visibleHeight < scrollableHeight - lineHeight
  }

  handleInput (event: any) {
    if (this.isMobile) {
      this.autoExpand(event.target)
    } else {
      this.computeOverlayVisibilities()
    }
    this.$emit('input', event)
  }

  handleBlur (event: FocusEvent) {
    this.$emit('blur', event)
  }

  autoExpand (field: HTMLElement) {
    // Reset field height so that scrollHeight will represent the height of the new inputted text
    field.style.height = 'inherit'
    // const computed = window.getComputedStyle(field)

    // Calculate the height
    const height = 
        field.scrollHeight
        // Don't need these with box-sizing: border-box; 
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10)
        // parseInt(computed.getPropertyValue('border-top-width'), 10) +
        // parseInt(computed.getPropertyValue('border-bottom-width'), 10)

    field.style.height = height + 'px'
  };
}
